import {ElementRef, Injectable} from '@angular/core';
import {DomManipulationService} from './dom-manipulation.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { DynamicScript } from '../../classes/dynamicScripts';
import { filter } from 'rxjs/operators';

@Injectable()
export class BrowserDomManipulationService extends DomManipulationService {

  private _scriptMap: { [id: string]: BehaviorSubject<boolean> } = {};

  loadScript(script: DynamicScript): Observable<boolean> {
    if (!this._scriptMap[script.id]) {
      this._scriptMap[script.id] = new BehaviorSubject<boolean>(false);
      const node = document.createElement('script');
      node.id = script.id;
      node.src = script.src;
      node.type = 'text/javascript';
      node.async = script.async;
      node.charset = 'utf-8';
      if (!script.globalCallback) {
        node.onload = () => this._scriptMap[script.id].next(true);
      } else {
        window[script.globalCallback] = () => this._scriptMap[script.id].next(true);
      }
      document.getElementsByTagName('head')[0].appendChild(node);
    }
    return this._scriptMap[script.id].pipe(filter(s => !!s));
  }

  removeElementById(scriptId: string) {
    const el = document.getElementById(scriptId);
    if (el) {
      el.parentNode.removeChild(el);
    }
    if (!!this._scriptMap[scriptId]) {
      this._scriptMap[scriptId].complete();
      delete this._scriptMap[scriptId];
    }
  }

  focus(element: ElementRef) {
    element.nativeElement.focus();
  }

  blur(element: ElementRef) {
    element.nativeElement.blur();
  }

  querySelectorAndSetInnerHTML(elementRef: ElementRef, querySelector: string, text: string) {
    elementRef.nativeElement.querySelector(querySelector).innerHTML = text;
  }

  scrollIntoView(element: ElementRef, top: boolean) {
    if (element) element.nativeElement.scrollIntoView();
    // element.nativeElement.scrollIntoView({ block: 'start', behavior: 'smooth'});
  }

  scrollToTop(elementRef?: ElementRef) {
    if (elementRef && elementRef.nativeElement) {
      elementRef.nativeElement.scrollTop = 0; // For Chrome, Safari and Opera
    }
    else {
      document.body.scrollTop = 0; // For Chrome, Safari and Opera
      document.documentElement.scrollTop = 0; // For IE and Firefox
    }
  }

  scrollTo(x: number, y: number) {
    window.scrollTo(x, y);
  }

  querySelectorContent(querySelector: string, description: string) {
    document.querySelector(querySelector).textContent = description;
  }

  querySelector(element: ElementRef, selector: string) {
    return element.nativeElement.querySelector(selector);
  }

  documentQuerySelectorHeight(selector: string): number {
    return document.querySelector(selector).scrollHeight;
  }

  runFunctionWithTimeout(func: any, timeout: number) {
    setTimeout(func, timeout);
  }
}
